module.exports = __webpack_public_path__ + "static/media/Bluelab-Large-Cassette-Only-1200ml-suitable_PUMPCASS-L_1.1f332c17.webp";